import { render, staticRenderFns } from "./TableSelectAlarmPriorityColor.vue?vue&type=template&id=2cb06785&scoped=true&"
import script from "./TableSelectAlarmPriorityColor.vue?vue&type=script&lang=js&"
export * from "./TableSelectAlarmPriorityColor.vue?vue&type=script&lang=js&"
import style0 from "./TableSelectAlarmPriorityColor.vue?vue&type=style&index=0&id=2cb06785&prod&scoped=true&lang=scss&"
import style1 from "./TableSelectAlarmPriorityColor.vue?vue&type=style&index=1&id=2cb06785&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb06785",
  null
  
)

export default component.exports